import { LinkBlockContentExtension } from "@tiptap-content/extensions/link/link-content-extensions"
import { ReactNodeViewRenderer } from "@tiptap/react"
import { LinkComponent } from "./link-component"

export const ExtensionLinkBlock = LinkBlockContentExtension.extend({
  addNodeView() {
    return ReactNodeViewRenderer(LinkComponent)
  },
})
